import { makeStyles } from '@mui/styles';

// Define estilos utilizando el hook makeStyles de Material-UI
const useStyles = makeStyles((theme) => ({
  // Estilos para el contenedor principal
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    paddingTop: theme.spacing(3),
  },
  // Estilos para el contenedor de filtros y botones
  filterAndButton: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing(2),
    borderRadius: '20px',
    width: '100%',
    flex: '1',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  // Estilos para el botón de añadir
  addButton: {
    marginTop: theme.spacing(3),
    transition: 'transform 0.3s',
    '&:hover': {
      transform: 'scale(1.1)',
      backgroundColor: theme.palette.success.light,
    },
    cursor: 'pointer',
  },
  // Estilos para el campo de búsqueda
  searchField: {
    marginTop: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      marginBottom: theme.spacing(2),
    },
  },
  // Estilos para el contenedor de la tabla
  tableContainer: {
    width: '100%',
    margin: 'auto',
    marginTop: '1%',
  },
  // Estilos para la tabla
  table: {
    minWidth: 650,
  },
  // Estilos para los botones de imagen (editar)
  imageButtonEditar: {
    width: '32px',
    '& > img': {
      margin: theme.spacing(0, 1),
      cursor: 'pointer',
      transition: 'transform 0.3s',
      '&:hover': {
        transform: 'scale(1.3)',
      },
    },
  },
  // Estilos para los botones de imagen (eliminar)
  imageButtonEliminar: {
    width: '32px',
    '& > img': {
      margin: theme.spacing(0, 1),
      cursor: 'pointer',
      transition: 'transform 0.3s',
      '&:hover': {
        transform: 'scale(1.3)',
      },
    },
  },
  // Estilos para los botones de imagen con margen
  imageButtonWithMargin: {
    '& > img': {
      margin: theme.spacing(0, 1),
      cursor: 'pointer',
      transition: 'transform 0.3s',
      '&:hover': {
        transform: 'scale(1.3)',
      },
    },
  },
  // Estilos para la fila de encabezado de la tabla
  headerRow: {
    backgroundColor: '#111827',
    '& th': {
      color: 'white',
    },
  },
  // Estilos para el modal (ventana emergente)
  modal: {
    position: 'absolute',
    width: '50%',
    backgroundColor: 'white',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4),
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  // Estilos para el título del modal
  modalTitle: {
    marginBottom: theme.spacing(2),
  },
  // Estilos para los campos de texto del modal
  modalTextField: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  // Estilos para los botones dentro del modal
  modalButtons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    width: '100%',
    marginTop: theme.spacing(2),
  },
  // Estilos para el botón de cancelar en el modal
  cancelarButton: {
    color: 'white', // Color del texto
    borderColor: '#fc0005', // Color del borde
    backgroundColor: '#fc0005', // Color de fondo rojo
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#d50000',
      borderColor: '#fc0005',
    },
  },
  // Estilos para el botón de guardar en el modal
  guardarButton: {
    backgroundColor: '#008000',
    '&:hover': {
      backgroundColor: theme.palette.success.light,
    },
    cursor: 'pointer',
  },
  // Estilos para un switch (interruptor) centrado
  centeredSwitch: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
  // Estilos personalizados para un switch
  customSwitch: {
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: theme.palette.success.main,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
      backgroundColor: theme.palette.success.main,
    },
  },
  // Estilos para el botón de imagen con margen en pantallas grandes
  '@media (min-width: 1200px)': {
    imageButtonWithMargin: {
      marginLeft: '30%',
    },
  },
}));

// Exporta los estilos definidos
export default useStyles;
